//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "../services/constants";
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";
import PDFTimesheetReport from "@/utils/pdfEmployeeTimesheetReport";
import moment from "moment";

export default {
  async mounted() {
    // this.$showLoader();
    await api.checkVersion();
    this.mycompany_id = localStorage.getItem(server.COMPANYID);
    this.loadEmp();
    this.loadCustomer();
    this.loadJobtitle();
    await this.loadDepartmentByCompanyId();
    await this.loadCompany();
    setTimeout(() => {
      this.$hideLoader();
    }, 500);
  },
  components: {
    SuccessDialog,
  },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.datasearch.datefrom);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.datasearch.dateto);
    },
  },
  data() {
    return {
      dialogSelectClientInfo: "1",
      dialogSelectTitle: false,
      showchargetype: "",
      checkdepartmentname: "",
      lengthAlldatasearch: 0,
      menudateto: false,
      menudatefrom: false,
      mycompany_id: 0,
      datasearch: {
        employeename: "",
        jobtitle_id: 0,
        chargetype: "",
        department: 0,
        // datefrom: "",
        // dateto: "",
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        // company_id: 13,
        company_id: localStorage.getItem(server.COMPANYID),
      },
      getnamesignature: [],
      prpoheader: [],
      memoref_list: [],
      no_list: [],
      mysignature: "",
      approvesignature: "",
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      dataforshowprpo: [
        // {
        //   DESCRIPTION: "Procurement - Tunnel",
        //   DIMENSION2_: "ENG-PJ-EP-21-007",
        //   ITEMID: "EN21007002",
        //   IVZ_BUDGETACCOUNT: "BEEQP-EN21007002",
        //   IVZ_BUDGETMODELID: "PJEP21-007",
        //   NAME:
        //     "Procurement - Tunnel\nค่าอากรขาเข้า \nค่าภาษีมูลค่าเพิ่ม \n\nRef No : 39280\nDate : 16/08/2565\nPP Business Coporation\n**ดำเนินการแล้วเสร็จ**",
        //   PURCHQTY: 1,
        //   PURCHREQID: "PR22-004569",
        //   PURCHUNIT: "ea",
        // },
      ],
      getheightcontentpr: 0,
      pageAll: 1,
      previewattachimage: "",
      dataformatpr: {
        title: "",
        subtitle: "Time Sheet Monthly Report",
        paymenttype: "Payment Type",
        companyname_addressrow1:
          "เลขที่ 142 อาคาร ทู แปซิฟิค เพลส ชั้น20 ถนนสุขุมวิท แขวงคลองเตย",
        companyname_addressrow2: "เขตคลองเตย กรุงเทพฯ 10110",
        pr_number: "เลขที่ใบขอซื้อ/PR Number",
        pr_date: "วันที่/PR Date",
        companyname_tel: "โทรศัพท์/Tel. 02-6530489-9",
        companyname_fax: "โทรสาร/Fax. 02-6533706",
        prtitle_th: "ใบขอซื้อ",
        prtitle_en: "PURCHASE REQUISTION",
      },
      dataformatprdetail: {
        project: "โครงการ/Project",
        department: "แผนก/Department",
        requist_date: "วันที่ต้องการ/Requist date",
        type: "ประเภท/Type",
        date_period: "วันที่เริ่มต้น-สิ้นสุด/Date period",
        objective: "วัตถุประสงค์/PR Name",
        vender: "ชื่อผู้จำหน่าย/Vender",
      },
      department_list: [],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      isShowPassword: false,
      fullPage: true,
      dialogEdit: false,
      dialogDelete: false,
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      closeDelete: false,
      deleteItemConfirm: false,
      emp_list: [],
      jobtitle_list: [],
      customer_list: [],
    };
  },
  methods: {
    async loadEmp() {
      const result = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID)
      );

      this.emp_list = result.data;
    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID)
      );

      this.jobtitle_list = result.data;
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListByCompany(
        localStorage.getItem(server.COMPANYID)
      );
      this.customer_list = result.data;
    },
    async loadCompany() {
      let copany_datat = await api.getCompanyByID(localStorage.getItem(server.COMPANYID));
      this.dataformatpr.title = copany_datat.data[0].name;
    },
    async loadDepartmentByCompanyId() {
      let result = await api.getNewAllDepartment_By_CompanyID(this.mycompany_id);
      console.log(result);
      this.department_list = result.data;
    },
    findChaege(chargetype) {
      this.charge_list.filter((item, index) => {
        console.log(item);
        if (item.value == chargetype) {
          this.showchargetype = item.name;
          return;
        }
      });
    },
    async OnSearchDepartment() {
      console.log(this.datasearch.department);
    },
    async opendata() {
      if (Number(localStorage.getItem(server.COMPANYID)) != 1 && Number(localStorage.getItem(server.COMPANYID)) != 3) {
        await this.SearchAlldata()
      } else {
        this.dialogSelectTitle = true;
      }
    },
    async SearchAlldata() {
      this.dialogSelectTitle = false;
      this.datashowAll = [];

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center"
        );
        return;
      }
      await this.$showLoader()
      this.lengthAlldatasearch = 0;
      this.datashowAll = [];
      const result = await api.getActivityforemployeesummaryreport({
        params: this.datasearch,
      });

      if (result.data.length == 0) {
        await this.$hideLoader()
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "ไม่มีข้อมูล",
          "text-h5 red--text text-center"
        );
        return;
      }
      this.lengthAlldatasearch = result.data.length;

      result.data.forEach(async (x, index) => {
        this.dataforshowprpo[0] = x;

        await this.checkcontent(this.dataforshowprpo[0]);
      });

      const headerPDF = await this.buildClientHeader();
      const clients = this.buildClientsFromData();

      const mockData = {
        header: headerPDF,
        clients: clients
      };

      PDFTimesheetReport.previewPDF(mockData);
      await this.$hideLoader()
    },
    async checkcontent(data) {
      let totalclient = 0;
      console.log("send data ====");
      console.log(this.dataforshowprpo[0]);
      // alert(data.length);
      this.setdatatoshow = [];
      let linedetailprpo = 34;
      let datainlineprpo = 45;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.dataforshowprpo[0].length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.dataforshowprpo[0][i].detail.length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.dataforshowprpo[0][i].no = i + 1;
        totalclient += parseFloat(
          this.dataforshowprpo[0][i].duration
            ? this.dataforshowprpo[0][i].duration
            : 0
        );
        if (i == 0) {
          this.checkdepartmentname = this.dataforshowprpo[0][i].job_name;
          this.dataforshowprpo[0][i].changedepartment = true;
        } else {
          if (
            this.checkdepartmentname !== this.dataforshowprpo[0][i].job_name
          ) {
            this.dataforshowprpo[0][i].changedepartment = true;
            this.checkdepartmentname = this.dataforshowprpo[0][i].job_name;
            hllinedetails++;
          }
        }
        stringchecklength = this.dataforshowprpo[0][i].detail;

        // let myArrayname = this.dataforshowprpo[i].NAME.split("\n");
        // for (let a = 0; a < myArrayname.length; a++) {
        //   let lengthnewline = myArrayname[a].length;
        //   for (let b = 0; b < myArrayname[a].length; b++) {
        //     if (
        //       myArrayname[a][b] == maiek ||
        //       myArrayname[a][b] == maito ||
        //       myArrayname[a][b] == maitree ||
        //       myArrayname[a][b] == maijattawa ||
        //       myArrayname[a][b] == vowelei ||
        //       myArrayname[a][b] == vowelee ||
        //       myArrayname[a][b] == voweleue ||
        //       myArrayname[a][b] == voweleu ||
        //       myArrayname[a][b] == vowelu ||
        //       myArrayname[a][b] == voweluu ||
        //       myArrayname[a][b] == maihun ||
        //       myArrayname[a][b] == maiyamok
        //     ) {
        //       lengthnewline--;
        //     }

        //   }

        for (let j = 0; j < this.dataforshowprpo[0][i].detail.length; j++) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        // newhllinedetails = Math.ceil(
        //   this.dataforshowprpo[i].NAME.length / datainlineprpo
        // );

        // newhllinedetails += addnewbutget;
        getnewdata.push(this.dataforshowprpo[0][i]);
        // console.log(getdata.length);
        // console.log(hllinedetails + newhllinedetails + getdata.length);
        // console.log(hllinedetails);
        // console.log(newhllinedetails);
        // console.log(getdata.length);
        // console.log("=================================");
        if (hllinedetails + newhllinedetails > linedetailprpo) {
          console.log(i + " ============== " + this.dataforshowprpo[0].length);
          this.setdatatoshow[this.pageAll - 1] = getdata;
          this.pageAll++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.dataforshowprpo[0][i]);
          hllinedetails += newhllinedetails;
          if (i == this.dataforshowprpo[0].length - 1) {
            this.dataforshowprpo[0][i].totalclient = totalclient.toFixed(2);
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.dataforshowprpo[0][i]);

          if (i == this.dataforshowprpo[0].length - 1) {
            this.dataforshowprpo[0][i].totalclient = totalclient.toFixed(2);
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.pageAll += this.lengthAlldatasearch - 1;
      this.opensummarize = true;
      console.log(this.pageAll);
      console.log("showwwwwwwwwwwwwwwwwwwww");
      console.log(this.setdatatoshow);

      this.setdatatoshow.forEach((item, iitem) => {
        console.log(item);
        console.log(iitem + " " + this.setdatatoshow[0].length);
        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });
      console.log(this.datashowAll);
    },
    buildClientsFromData() {
      const data = this.datashowAll || [];

      const clientsMap = {};

      data.forEach((group) => {
        if (!Array.isArray(group)) return;

        group.forEach((item) => {
          const customerName = item.fullname?.trim() || "Unspecified Employee";

          // ================= INIT CLIENT =================
          if (!clientsMap[customerName]) {
            clientsMap[customerName] = {
              client_name: customerName,
              items: [],
            };
          }

          // ================= ASSIGNMENT =================
          const assignment =
            item.job_name?.trim() || "Unspecified";

          // ================= PUSH ITEM =================
          clientsMap[customerName].items.push({
            assignment: assignment,

            date: item.checkindate || null,

            case_worker: item.abbname_e_n || "",

            detail: item.detail || "",

            hour: item.duration || 0,

            chargetype: item.chargetype || "",
          });
        });
      });

      // ================= SORT: Unspecified LAST =================
      const clients = Object.values(clientsMap);

      clients.forEach((client) => {
        const grouped = {};

        client.items.forEach((item) => {
          const key = item.assignment;

          if (!grouped[key]) grouped[key] = [];
          grouped[key].push(item);
        });

        const sortedKeys = Object.keys(grouped).sort((a, b) => {
          if (a === "Unspecified") return 1;
          if (b === "Unspecified") return -1;
          return a.localeCompare(b);
        });

        client.items = sortedKeys.flatMap((key) => grouped[key]);
      });

      return clients.sort((a, b) => {
        const nameA = a.client_name || "";
        const nameB = b.client_name || "";

        // ================= Unspecified ไปท้ายสุด =================
        const isUnA = nameA === "Unspecified Employee";
        const isUnB = nameB === "Unspecified Employee";

        if (isUnA && !isUnB) return 1;
        if (!isUnA && isUnB) return -1;

        // ================= เรียง A-Z =================
        return nameA.localeCompare(nameB, "en", {
          sensitivity: "base",
        });
      });
    },
    async buildClientHeader() {
      var res_company = [];
      if (Number(localStorage.getItem(server.COMPANYID)) != 1) {
        res_company = await api.getCompanyByID(localStorage.getItem(server.COMPANYID))
      } else {
        res_company = await api.getCompanyByID(Number(this.dialogSelectClientInfo))
      }

      var headerPDF = {};

      headerPDF = {
        company_name_en: res_company.data[0].name || "",
        company_name_th: res_company.data[0].inv_company_name_th || "",
        inv_company_sub_name: "ATTORNEY AT LAW",
        date_from: this.datasearch.datefrom,
        date_to: this.datasearch.dateto,
        issue_date: moment().format("YYYY-MM-DD"),
        department: "All"
      }

      if (Number(localStorage.getItem(server.COMPANYID)) != 1) {
        headerPDF.inv_company_sub_name = "";
      }

      if (Number(this.datasearch.department) != 0) {
        const targetId = Number(this.datasearch.department);
        const department_name = this.department_list.find(item => Number(item.id) === Number(targetId));
        headerPDF.department = department_name.department_name
      }
      return headerPDF;
    },
    async exportToPDF() {
      await this.$showLoader();
      const headerPDF = await this.buildClientHeader();
      const clients = this.buildClientsFromData();

      const mockData = {
        header: headerPDF,
        clients: clients
      };

      await PDFTimesheetReport.exportToPDF(mockData);
      await this.$hideLoader();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
